module.exports = __webpack_public_path__ + "static/media/IMG_0316.172d3d0c.JPG";